// packageDataStore.js

export let packageNamesList = [];
export let combinedTestList = [];

// This function will be called once the response arrives
export const importPackageData = (response) => {
  packageNamesList = response.packageNames || [];
  combinedTestList = response.combinedList || [];
};
